module.exports = __webpack_public_path__ + "static/icon-import-export-8a8fb7e055a7bd39e83b254ae88c6b25.svg";